// @flow
import React, { Component } from 'react'
import _ from 'lodash'
import { zeroWhenIsNil } from '../../services/statistics/utils'
import { translateFunc, translations } from '../../shared/localize'
import styled, { type StyledComponent } from 'styled-components'

export const TYPES = {
  NUMBER: 'TYPES.NUMBER',
  PERCENT: 'TYPES.PERCENT'
}

const AdsProviderStat: StyledComponent<Object, any, any> = styled.div`
  font-size: 14px;
`

type Props = {|
  statistics: Object,
  type: string,
  property: string
|}

const t = translateFunc(translations.provider_short_translations)

export default class StatisticsCell extends Component<Props> {
  value() {
    const { type, property, statistics } = this.props
    const value = zeroWhenIsNil(statistics[property])

    switch (type) {
      case TYPES.NUMBER:
        return `${_.round(value, 2)}`
      case TYPES.PERCENT:
        return `${_.round(value * 100, 2)}%`
      default:
        throw new Error('')
    }
  }

  render() {
    const { statistics } = this.props
    // uses {_: ''} in case of an not found translation
    const providerName = t(statistics.providerName, { _: '' })
    const prefix = providerName ? `${providerName}: ` : ''
    return (
      <AdsProviderStat className={statistics.providerName}>
        {`${prefix}${this.value()}`}
      </AdsProviderStat>
    )
  }
}
